<script module>
  export const archiveModal = new ModalQueryState('archive');
</script>

<script lang="ts">
  import Home from '~icons/mdi/home';
  import Close from '~icons/mdi/close';
  import ActionButton from '~/components/ActionButton.svelte';

  import Modal from '~/components/Modal.svelte';
  import Premium from '~/icons/Premium.svelte';
  import Calendar, { calendarPage, selectedDate } from './Calendar.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import { isPremium } from '~/lib/queries.svelte';
  import ArchiveIcon from '~/icons/ArchiveIcon.svelte';
  import { page } from '$app/state';
  import NewDaily from '~/icons/NewDaily.svelte';
  import { dateToString, getTodayUTC } from '~/utils/dates';

  const premium = isPremium();
  const fromHome = $derived(archiveModal.value === 'b');

  const titleCase = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

  const title = $derived(titleCase(page.params.mode ?? ''));

  const handleClose = () => {
    archiveModal.pop();
  };

  const handleClickToday = () => {
    const today = getTodayUTC();
    calendarPage.current = {
      month: today.getUTCMonth(),
      year: today.getUTCFullYear(),
    };
    selectedDate.current = dateToString(today);
  };
</script>

<ActionButton
  href={premium.data ? '?archive=t' : '?premium=t#archive'}
  outlink={false}
>
  <ArchiveIcon size="1.5em" />
  {title} Archive
  <div class="spacer"></div>
  <Premium size="1.5em" />
</ActionButton>
<Modal open={archiveModal.open} onClose={handleClose} index={2}>
  {#snippet title()}
    <div class="title">
      <ArchiveIcon size="1em" />
      {title} Archive
    </div>
  {/snippet}
  {#snippet content()}
    <div class="content">
      <Calendar />
    </div>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}>
      {#if fromHome}
        <Home />
        Home
      {:else}
        <Close />
        Close
      {/if}
    </ActionButton>
    <ActionButton onClick={handleClickToday}>
      <NewDaily />
      Today
    </ActionButton>
  {/snippet}
</Modal>

<style lang="scss">
  @use '~/theme/include-media' as *;
  .title {
    display: flex;
    gap: 0.5em;
    align-items: center;
    margin-top: -0.25em;
    margin-bottom: -0.75em;
  }
  .content {
    @include media('<tablet') {
      margin: -0.5em;
    }
  }
  .spacer {
    flex: 1;
  }
</style>
